// @ts-nocheck

import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';

export const withEmptyRow = (
  values: any[] = [],
  options: {
    emptyRow?: any;
    ignoredEmptyRowKeys?: string[];
    maxLength?: number;
  } = {}
) => {
  const defaultOptions = {
    emptyRow: {},
    ignoredEmptyRowKeys: [],
  };
  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };
  const { emptyRow, ignoredEmptyRowKeys, maxLength } = mergedOptions;
  const hasEmptyRow = (items: any[]) => {
    if (!items.length) {
      return false;
    }
    const ignoredKeys = ignoredEmptyRowKeys ?? [];
    const lastValue = omit(items[items.length - 1], ...ignoredKeys);
    const withoutKeysEmptyRow = omit(emptyRow, ...ignoredKeys);
    return isEqual(lastValue, withoutKeysEmptyRow);
  };
  if (maxLength && values.length >= maxLength) return values;
  if (hasEmptyRow(values)) return values;
  return [...values, emptyRow];
};

export const withoutEmptyRow = (
  values: any[],
  emptyRow = {},
  ignoredEmptyRowKeys: string[] = []
) => {
  return values.filter((value) => {
    const valueWithoutKeys = omit(value, ...ignoredEmptyRowKeys);
    const emptyRowWithoutKeys = omit(emptyRow, ...ignoredEmptyRowKeys);
    return !isEqual(valueWithoutKeys, emptyRowWithoutKeys);
  });
};
